var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import TextTransition, { presets } from "react-text-transition";
export var PerCharacterTextTransition = function (_a) {
    var value = _a.value, className = _a.className, springConfig = _a.springConfig;
    return (_jsx(_Fragment, { children: Array.from(value).map(function (char, i) { return (_jsx(TextTransition, __assign({ delay: i * 100, className: className, springConfig: springConfig !== null && springConfig !== void 0 ? springConfig : presets.wobbly, inline: true, translateValue: "33%" }, { children: char }), i)); }) }));
};
